import React, { useEffect, useState } from 'react';
import { AccProfileSubFactorVO } from '@domain/vo/acca/v1/test/result/competence/AccProfileResultVO';
import classNames from 'classnames/bind';
import styles from './competencyDetails.module.scss';

interface CompetencyDetailsProps {
  accProfileSubFactor: AccProfileSubFactorVO[] | null;
}

const cx = classNames.bind(styles);

const CompetencyDetails = ({ accProfileSubFactor }: CompetencyDetailsProps) => {
  const [subFactorTab, setSubFactorTab] = useState(0);

  useEffect(() => {
    setSubFactorTab(0);
  }, [accProfileSubFactor]);

  if (!accProfileSubFactor) return null;

  const tabs = accProfileSubFactor.map(({ keyword }, index) => {
    const isOn = subFactorTab === index;
    const handleClick = () => setSubFactorTab(index);

    return (
      <button key={index} className={cx('tab', { active: isOn })} onClick={handleClick}>
        {keyword}
      </button>
    );
  });

  return (
    <div className={cx('wrapper')}>
      <div className={cx('tabArea')}>{tabs}</div>
      <p className={cx('description')}>{accProfileSubFactor[subFactorTab]?.comment ?? ''}</p>
    </div>
  );
};

export default CompetencyDetails;
